import React from 'react';
import { ModuleBase, Stack, ResponsiveImage } from '@/components';
import { SideBySideModuleModel } from './SideBySideModule';
import { animControllerInView, fadeIn } from '@/animations';
import classNames from 'classnames';

const HomepageStats = (data: SideBySideModuleModel) => {
  const {
    props: { image, cards },
  } = data;

  return (
    <ModuleBase
      data={data}
      noPadding
      className="HomepageStats flex snap-end flex-col items-center justify-end overflow-hidden md:h-[calc(100vh-var(--header-height))] lg:flex-row"
    >
      {/*
      <div className="relative aspect-square w-full overflow-hidden lg:hidden">
        {image && image.desktopImage && (
          <ResponsiveImage
            animation={fadeIn}
            image={image.desktopImage}
            widths={{ xs: 425, sm: 650, md: 768, lg: 1, xl: 1, xxl: 1 }}
            heights={{ xs: 425, sm: 650, md: 768, lg: 1, xl: 1, xxl: 1 }}
          />
        )}
        <div className="absolute top-2/4 left-2/4 block aspect-square w-full -translate-x-2/4 -translate-y-2/4 rounded-full border border-white lg:h-auto lg:w-full" />
      </div>
      */}
      <div className="left-0 flex w-full flex-col items-center lg:absolute lg:h-auto">
        <div className="container flex h-full px-0 lg:justify-start">
          <Stack
            animation={animControllerInView({ amount: 0.3, staggerChildren: 0.1 })}
            className="flex h-full flex-wrap md:h-auto lg:h-[calc(100vh-var(--header-height))] lg:w-1/2"
          >
            {cards &&
              cards.map((cards, index) => (
                <div
                  key={index}
                  className={classNames(
                    'relative flex h-[126px] w-1/2 flex-col border-black p-3 even:border-l sm:p-5 md:h-auto md:p-7 xl:p-9',
                    index !== 0 && index !== 1 && 'after-extended-line-top after:right-0 after:left-[unset]',
                  )}
                >
                  <div className="flex flex-col gap-1 md:gap-2 lg:gap-5">
                    <div className="text-style-h2 xl:!text-[75px] xl:leading-[75px]">{cards.title}</div>
                    {cards.text && <div className="text-style-body" dangerouslySetInnerHTML={{ __html: cards.text }} />}
                  </div>
                </div>
              ))}
          </Stack>
        </div>
      </div>
    </ModuleBase>
  );
};

export default HomepageStats;
